import { Component, OnInit, ViewChild } from '@angular/core';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';

import { AgGridModule } from 'ag-grid-angular';
import { GridApi, GridReadyEvent, CellClickedEvent } from 'ag-grid-community';

@Component({
  selector: 'app-add-video',
  standalone: true,
  imports: [
    CommonModule, // ✅ for *ngIf, *ngFor, ngStyle
    FormsModule, // ✅ for [(ngModel)]
    ReactiveFormsModule, // ✅ for reactive forms
    AgGridModule, // ✅ AG Grid
  ],
  templateUrl: './add-video.component.html',
  styleUrls: ['./add-video.component.scss'],
})
export class AddVideoComponent implements OnInit {
  @ViewChild('agGrid') agGrid: any;

  // AG Grid API
  gridApi!: GridApi;

  display: any = 'none';
  colleges: any;
  displayDelete: any = 'none';
  fileToUpload: any;
  imageUrl: any;
  collegeId: any;
  videoUrl: any;

  videoForm: UntypedFormGroup;

  showErr = false;
  deleteErr: any;

  showEdit = false;
  showAdd = false;

  showData = false;
  showNodata = false;

  searchval: any;

  error_messages = {
    imageVal: [{ type: 'required', message: 'Please select image' }],
    colgVal: [{ type: 'required', message: 'Please select college name' }],
    videoVal: [{ type: 'required', message: 'Please enter video url' }],
  };
  videos: any;
  id: any;
  adminName: any;
  adminImage: any;
  allVideos: any;
  allData: any;
  imageTrueFalse: boolean = false;
  payload: any;

  // AG Grid definitions
  columnDefs = [
    {
      headerName: 'S.NO',
      valueGetter: 'node.rowIndex + 1',
      width: 90,
      sortable: true,
    },
    {
      headerName: 'College Name',
      field: 'collage_name',
      sortable: true,
      filter: true,
      flex: 1,
    },
    {
      headerName: 'Video URL',
      field: 'url',
      sortable: true,
      filter: true,
      cellRenderer: (params: any) => {
        const img = params.data?.image
          ? `<img width="30" height="30" src="${params.data.image}" class="rounded-circle" style="vertical-align:middle;margin-right:8px;">`
          : '';
        return `${img}<span>${params.value || ''}</span>`;
      },
      flex: 2,
    },
    {
      headerName: 'Actions',
      field: 'actions',
      cellRenderer: (params: any) => {
        // the icon has class 'iconEdit' so we can detect clicks on it
        return `<i class="fa fa-trash-o iconEdit" aria-hidden="true" style="cursor:pointer"></i>`;
      },
      width: 110,
      suppressMenu: true,
      sortable: false,
      filter: false,
    },
  ];

  defaultColDef = {
    resizable: true,
    sortable: true,
    filter: true,
    minWidth: 80,
  };

  rowData: any[] = []; // will be set from allVideos

  // internal storage for fetched videos
  allVideosInternal: any[] = [];

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    // initialize form
    this.videoForm = this.formBuilder.group({
      imageVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      colgVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      videoVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    // load admin details safely
    try {
      const admin = JSON.parse(localStorage.getItem('adminDetails') as string);
      const adminData = JSON.parse(admin);
      this.adminName = adminData[0].name;
      this.adminImage = adminData[0].image;
      if (this.adminImage == null || this.adminImage == undefined) {
        this.adminImage = 'assets/tenant-avatar.jpg';
      }
    } catch (e) {
      this.adminName = '';
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    this.videoForm.reset();
    this.fetchColleges();
    this.fetchVideos();
  }

  fetchColleges(): void {
    const servicePathCollege = this.utils.getApiConfigs('college');
    this.commonservice
      .invokeService(
        servicePathCollege[1].method,
        servicePathCollege[1].path,
        ''
      )
      .then((resp: any) => {
        if (resp.status_code == '200') {
          this.colleges = resp.data;
        }
      })
      .catch((err) => {
        console.error('Error fetching colleges', err);
      });
  }

  fetchVideos(): void {
    this.spinner.show();
    const servicePathVideo = this.utils.getApiConfigs('allvideourl');
    this.commonservice
      .invokeService(servicePathVideo[0].method, servicePathVideo[0].path, '')
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.videos = Array.isArray(resp.data) ? resp.data : [];
          // initialize internal copy and grid
          this.allVideosInternal = this.videos.slice();
          this.setRowDataFromAllVideos();

          if (this.allVideosInternal.length === 0) {
            this.showNodata = true;
            this.showData = false;
          } else {
            this.showData = true;
            this.showNodata = false;
          }
        } else {
          this.videos = [];
          this.allVideosInternal = [];
          this.setRowDataFromAllVideos();
          this.showNodata = true;
          this.showData = false;
        }
      })
      .catch((err) => {
        this.spinner.hide();
        console.error('Error fetching videos', err);
        this.videos = [];
        this.allVideosInternal = [];
        this.setRowDataFromAllVideos();
        this.showNodata = true;
        this.showData = false;
      });
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    // seed grid if rowData already set
    if (this.rowData && this.rowData.length) {
      try {
        (this.gridApi as any).applyTransaction({ replace: this.rowData });
      } catch {
        (this.gridApi as any).setRowData(this.rowData);
      }
    }
  }

  // --- called on input (bound to (input)="onQuickFilterChanged()" )
  onQuickFilterChanged() {
    const q = this.searchval
      ? this.searchval.toString().trim().toLowerCase()
      : '';

    // start from the original fetched data
    const source = Array.isArray(this.videos) ? this.videos : [];

    if (!q) {
      // restore original data
      this.allVideosInternal = source.slice();
    } else {
      // filter across fields you want (here: college name, url)
      this.allVideosInternal = source.filter((r: any) => {
        const name = (r.collage_name || '').toString().toLowerCase();
        const url = (r.url || '').toString().toLowerCase();
        // add more fields here if needed
        return name.includes(q) || url.includes(q);
      });
    }

    // update grid rows (typed approach with fallback)
    if (this.gridApi) {
      try {
        // prefer applyTransaction replace (if supported)
        (this.gridApi as any).applyTransaction({
          replace: this.allVideosInternal,
        });
      } catch (err) {
        (this.gridApi as any).setRowData(this.allVideosInternal);
      }
    } else {
      // if grid not ready yet, set rowData so gridReady will pick it up
      this.rowData = this.allVideosInternal;
    }

    // update visibility flags
    this.updateTableVisibility();
  }

  // --- clear search button
  clearSearch() {
    this.searchval = '';
    this.onQuickFilterChanged();
  }

  setRowDataFromAllVideos() {
    this.rowData = this.allVideosInternal;
    if (this.gridApi) {
      try {
        (this.gridApi as any).applyTransaction({ replace: this.rowData });
      } catch {
        (this.gridApi as any).setRowData(this.rowData);
      }
    }
    this.updateTableVisibility();
  }

  updateTableVisibility() {
    if (!this.rowData || this.rowData.length === 0) {
      this.showData = false;
      this.showNodata = true;
    } else {
      this.showData = true;
      this.showNodata = false;
    }
  }

  onChangeEvent(event: any) {
    var val = event.target.value;
    this.allData = this.videos;
    if (val) {
      this.allVideos = this.allData.filter((item: any) =>
        (item.collage_name || '').toLowerCase().includes(val.toLowerCase())
      );
    } else {
      this.allVideos = this.allData;
    }

    this.allVideosInternal = this.allVideos;
    this.setRowDataFromAllVideos();

    if (!this.allVideos || this.allVideos.length === 0) {
      this.globalService.showError('No data found');
    }
  }

  reset() {
    this.searchval = '';
    this.fetchVideos();
  }

  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;
      this.imageTrueFalse = true;
    };
    reader.readAsDataURL(this.fileToUpload);
  }

  openAdd() {
    this.display = 'block';
    this.imageUrl = 'assets/tenant-avatar.jpg';
    this.videoForm.reset();
    this.showAdd = true;
    this.showEdit = false;
  }

  onCloseHandled() {
    this.display = 'none';
    this.displayDelete = 'none';
  }

  editVideo(data: any) {
    this.display = 'block';
    this.showAdd = false;
    this.showEdit = true;

    this.videoUrl = data.url;
    this.imageUrl = data.image;
    this.collegeId = data.college_id;
  }

  deleteVideo(data: any) {
    this.displayDelete = 'block';
    this.deleteErr = '';
    this.id = data.id;
  }

  addVideo() {
    this.spinner.show();
    let payload = {
      college_id: this.collegeId,
      url: this.videoUrl,
      user_image: this.imageUrl,
    };

    const servicePath = this.utils.getApiConfigs('videourl');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.globalService.showSuccess('Video added Successfully');
          this.display = 'none';
          this.videoForm.reset();
          this.fetchVideos();
        } else if (resp.status_code == '400') {
          this.globalService.showError(resp.data);
        }
      })
      .catch((err) => {
        this.spinner.hide();
        console.error('addVideo error', err);
      });
  }

  updateVideo() {
    this.spinner.show();
    if ((this.imageTrueFalse = true)) {
      this.payload = {
        college_id: this.collegeId,
        url: this.videoUrl,
        user_image: this.imageUrl,
      };
    } else {
      this.payload = {
        college_id: this.collegeId,
        url: this.videoUrl,
      };
    }

    const servicePath = this.utils.getApiConfigs('videourl');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, this.payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.globalService.showSuccess('Video added Successfully');
          this.fetchVideos();
          this.videoForm.reset();
          this.imageTrueFalse = false;
        } else if (resp.status_code == '400') {
          this.globalService.showError(resp.data);
        }
      })
      .catch((err) => {
        this.spinner.hide();
        console.error('updateVideo error', err);
      });
  }

  delete() {
    this.spinner.show();
    let payload = {
      id: this.id,
    };
    const servicePath = this.utils.getApiConfigs('deletecollegevideo');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.globalService.showSuccess('Video URL deleted successfully');
          this.displayDelete = 'none';
          this.fetchVideos();
        } else if (resp.status_code == '400') {
          this.globalService.showError(resp.data);
          this.showErr = true;
          this.deleteErr = resp.data;
        }
      })
      .catch((err) => {
        this.spinner.hide();
        console.error('delete error', err);
      });
  }

  /** Detect clicks inside AG Grid cell */
  onCellClicked(event: CellClickedEvent) {
    const clickedEl = event?.event?.target as HTMLElement;
    if (
      clickedEl &&
      clickedEl.classList &&
      clickedEl.classList.contains('iconEdit')
    ) {
      this.deleteVideo(event.data);
    }
  }
}
